import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const areas = [
  {
    id: 'palm-coast',
    city: 'Palm Coast',
    state: 'FL',
    desc: "Dippel's Outdoor Services proudly serves Palm Coast, FL with professional fencing, custom paver installation, landscape design, architectural outdoor lighting, and premium shed construction. Palm Coast homeowners trust Dippel's for reliable, expert-level outdoor work.",
    image: 'https://public.readdy.ai/ai/img_res/10828308eb59ff27f945542a8a2ffebc.jpg',
    services: ['Fences', 'Pavers', 'Landscape', 'Lighting', 'Sheds'],
  },
  {
    id: 'ormond-beach',
    city: 'Ormond Beach',
    state: 'FL',
    desc: "Based in the heart of Volusia County, Dippel's Outdoor Services has deep roots in Ormond Beach, FL. We deliver premium fencing, pavers, landscape installation, and complete outdoor living upgrades to Ormond Beach homeowners who demand quality.",
    image: 'https://readdy.ai/api/search-image?query=luxury%20outdoor%20fence%20installation%20premium%20Florida%20residential%20property%20elegant%20white%20vinyl%20fence%20lush%20manicured%20lawn%20Ormond%20Beach%20upscale&width=800&height=600&seq=dippels-area-ormond&orientation=landscape',
    services: ['Fences', 'Pavers', 'Landscape', 'Lighting', 'Sheds'],
  },
  {
    id: 'daytona-beach',
    city: 'Daytona Beach',
    state: 'FL',
    desc: "Dippel's Outdoor Services serves Daytona Beach, FL with full-service landscaping, fencing, paver patios and driveways, outdoor lighting, and custom sheds. Our experienced team helps Daytona Beach homeowners elevate their outdoor spaces.",
    image: 'https://readdy.ai/api/search-image?query=luxury%20paver%20driveway%20outdoor%20living%20space%20Florida%20Daytona%20Beach%20high-end%20natural%20stone%20elegant%20residential%20professional%20craftsmanship&width=800&height=600&seq=dippels-area-daytona&orientation=landscape',
    services: ['Fences', 'Pavers', 'Landscape', 'Lighting', 'Sheds'],
  },
  {
    id: 'port-orange',
    city: 'Port Orange',
    state: 'FL',
    desc: "Port Orange, FL homeowners choose Dippel's Outdoor Services for dependable, high-quality fence installation, paver systems, landscape design, and custom sheds. We're proud to serve one of Volusia County's most vibrant communities.",
    image: 'https://readdy.ai/api/search-image?query=elegant%20outdoor%20landscape%20lighting%20luxury%20Florida%20home%20Port%20Orange%20warm%20amber%20pathway%20lights%20premium%20garden%20design%20upscale&width=800&height=600&seq=dippels-area-portorange&orientation=landscape',
    services: ['Fences', 'Pavers', 'Landscape', 'Lighting', 'Sheds'],
  },
  {
    id: 'new-smyrna-beach',
    city: 'New Smyrna Beach',
    state: 'FL',
    desc: "Dippel's Outdoor Services brings premium outdoor services to New Smyrna Beach, FL. From beautiful paver driveways to lush landscape installations, our team helps New Smyrna Beach property owners create stunning outdoor environments.",
    image: 'https://readdy.ai/api/search-image?query=luxury%20residential%20landscape%20installation%20Florida%20New%20Smyrna%20Beach%20lush%20tropical%20planting%20sod%20lawn%20premium%20vibrant%20green%20professional%20upscale&width=800&height=600&seq=dippels-area-nsb&orientation=landscape',
    services: ['Fences', 'Pavers', 'Landscape', 'Lighting', 'Sheds'],
  },
  {
    id: 'edgewater',
    city: 'Edgewater',
    state: 'FL',
    desc: "Edgewater, FL residents trust Dippel's Outdoor Services for expert fencing, pavers, sod installation, landscape lighting, and custom storage sheds. We serve Edgewater with the same premium quality we bring to all our Florida service areas.",
    image: 'https://readdy.ai/api/search-image?query=premium%20custom%20shed%20luxury%20backyard%20Florida%20Edgewater%20elegant%20design%20professional%20construction%20manicured%20lawn%20upscale%20residential&width=800&height=600&seq=dippels-area-edgewater&orientation=landscape',
    services: ['Fences', 'Pavers', 'Landscape', 'Lighting', 'Sheds'],
  },
];

export default function ServiceAreasPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        {/* Cinematic Hero */}
        <section className="relative overflow-hidden" style={{ minHeight: '520px' }}>
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=aerial%20view%20luxury%20Florida%20residential%20neighborhood%20upscale%20homes%20lush%20tropical%20landscaping%20premium%20outdoor%20living%20spaces%20elegant%20community%20golden%20light&width=1920&height=800&seq=dippels-areas-hero&orientation=landscape"
              alt="Dippel's Outdoor Services — Florida service areas"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/35"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          </div>
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-gold to-transparent opacity-60"></div>

          <div className="relative z-10 max-w-4xl mx-auto px-6 py-36">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-gold"></div>
              <span className="text-gold text-[11px] font-semibold tracking-[0.28em] uppercase">Where We Work</span>
            </div>
            <h1 className="font-serif text-white font-bold leading-tight mb-5" style={{ fontSize: 'clamp(38px, 4.5vw, 60px)' }}>
              Serving Florida&apos;s East Coast<br />
              <em className="text-gold not-italic">One Property at a Time</em>
            </h1>
            <p className="text-white/60 text-base leading-relaxed mb-8 max-w-lg">
              Dippel's Outdoor Services delivers premium fencing, pavers, landscaping, and outdoor services across Volusia and Flagler County.
            </p>
            <div className="flex flex-wrap gap-2">
              {areas.map((a) => (
                <a
                  key={a.id}
                  href={`#${a.id}`}
                  className="bg-white/10 border border-white/15 hover:bg-gold/20 hover:border-gold/40 text-white text-[13px] font-medium px-4 py-2 rounded-full transition-colors whitespace-nowrap"
                >
                  {a.city}, FL
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Trust strip */}
        <section className="bg-charcoal border-b border-white/8 py-0">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/8">
              {[
                { icon: 'ri-star-fill', value: '5-Star', label: 'Google Rated', accent: true },
                { icon: 'ri-map-pin-2-fill', value: '6 Cities', label: 'Served in Florida', accent: false },
                { icon: 'ri-shield-check-fill', value: 'Licensed', label: '& Fully Insured', accent: true },
                { icon: 'ri-tools-fill', value: '5 Services', label: 'Fully Offered', accent: false },
              ].map((s, i) => (
                <div key={i} className="flex items-center gap-4 px-8 py-6">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${s.accent ? 'bg-gold/15 text-gold' : 'bg-forest/20 text-forest-light'}`}>
                    <i className={`${s.icon} text-base`}></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{s.value}</p>
                    <p className="text-white/45 text-xs">{s.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Map Overview */}
        <section className="bg-cream py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <p className="text-center text-charcoal-muted text-sm mb-5 font-medium">Our complete service area covers Volusia &amp; Flagler County, Florida</p>
            <div className="rounded-2xl overflow-hidden border border-stone-dark" style={{ height: '420px' }}>
              <iframe
                title="Dippel's Outdoor Services Florida Service Areas Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d221576.2729994!2d-81.2453!3d29.0228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e73fb6defa2f9b%3A0xa7948486a71768ac!2sDippel%27s%20Outdoor%20Services!5e0!3m2!1sen!2sus!4v1710000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </section>

        {/* Each Area */}
        {areas.map((area, idx) => (
          <section
            key={area.id}
            id={area.id}
            className={`py-24 px-6 ${idx % 2 === 0 ? 'bg-white' : 'bg-stone'}`}
          >
            <div className="max-w-7xl mx-auto">
              <div className="grid lg:grid-cols-2 gap-14 items-center">
                {/* Image */}
                <div className={`${idx % 2 !== 0 ? 'lg:order-2' : ''} relative`}>
                  <div className="w-full h-80 rounded-2xl overflow-hidden">
                    <img
                      src={area.image}
                      alt={`Outdoor services in ${area.city}, FL — Dippel's`}
                      className="w-full h-full object-cover object-top hover:scale-[1.03] transition-transform duration-700"
                    />
                  </div>
                  {/* City badge */}
                  <div className="absolute top-5 left-5 flex items-center gap-2 bg-charcoal/85 backdrop-blur-sm text-white text-[11px] font-semibold tracking-wide px-3 py-2 rounded-full border border-white/10">
                    <i className="ri-map-pin-fill text-gold text-xs"></i>
                    {area.city}, {area.state}
                  </div>
                </div>

                {/* Content */}
                <div className={idx % 2 !== 0 ? 'lg:order-1' : ''}>
                  <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3">
                    <span className="h-px w-8 bg-gold inline-block"></span>
                    {area.city}, {area.state}
                  </p>
                  <h2 className="font-serif text-charcoal font-bold mb-5" style={{ fontSize: 'clamp(26px, 2.5vw, 38px)' }}>
                    Outdoor Services in {area.city}, {area.state}
                  </h2>
                  <p className="text-charcoal-muted text-[14px] leading-relaxed mb-7">{area.desc}</p>

                  <div className="flex flex-wrap gap-2 mb-8">
                    {area.services.map((svc) => (
                      <span key={svc} className="text-xs bg-forest/10 text-forest font-medium px-3 py-1.5 rounded-full border border-forest/15">
                        {svc} in {area.city}
                      </span>
                    ))}
                  </div>

                  <div className="flex gap-3">
                    <Link
                      to="/contact"
                      className="inline-flex items-center gap-2 bg-charcoal text-white font-semibold px-7 py-3.5 rounded-full hover:bg-forest text-sm transition-colors whitespace-nowrap"
                    >
                      Free Estimate in {area.city}
                    </Link>
                    <a
                      href="tel:3863014399"
                      className="inline-flex items-center gap-2 border border-charcoal/20 text-charcoal font-semibold px-6 py-3.5 rounded-full hover:bg-stone text-sm transition-colors whitespace-nowrap"
                    >
                      <i className="ri-phone-fill text-gold"></i>
                      Call Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}

        {/* Final CTA */}
        <section className="bg-charcoal py-20 px-6 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="h-px w-10 bg-gold"></div>
              <span className="text-gold text-[11px] font-semibold tracking-[0.28em] uppercase">Don't See Your City?</span>
              <div className="h-px w-10 bg-gold"></div>
            </div>
            <h2 className="font-serif text-white font-bold mb-4" style={{ fontSize: 'clamp(28px, 3vw, 42px)' }}>
              We May Still Be Able to Serve You
            </h2>
            <p className="text-white/50 text-base mb-10 leading-relaxed">
              Dippel's serves the greater Volusia and Flagler County region. Call us to confirm availability for your specific address — no obligation.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="tel:3863014399"
                className="inline-flex items-center justify-center gap-2 bg-gold text-charcoal font-bold px-9 py-4 rounded-full hover:bg-gold-light transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                Call (386) 301-4399
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-semibold px-9 py-4 rounded-full hover:border-white/50 transition-colors whitespace-nowrap"
              >
                Contact Us Online
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
